import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Input, Table, Tooltip } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import axios from "axios";
import { UserInfo } from "../../../../context";
import MerchantEmployeeLayout from "../../../layout/MerchantEmployeeLayout";
import MerchantEmployeeSetPermission from "./MerchantEmployeeSetPermission";

const MerchantEmployeeList = () => {
  const [employeeList, setEmployeeList] = useState({
    data: [],
    ready: false,
  });
  const [loading, setLoading] = useState(false);
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [setPermissionDrawer, setSetPermissionDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [search, setSearch] = useState("");

  const columns = [
    {
      title: "Fullname",
      render: (text, record) => (
        <p>
          {text.lastname}, {text.firstname} {text.middle}
        </p>
      ),
    },
    {
      title: "Address",
      render: (text, record) => (
        <p style={{ textTransform: "uppercase" }}>
          {text.street}, {text.barangay}, {text.city}
        </p>
      ),
    },
    {
      title: "Contact #",
      dataIndex: "contact_no",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Position",
      dataIndex: ["merchantemployeeposition", "position"],
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 110,
      render: (text) => (
        <p style={{ width: window.innerWidth > 883 ? "auto" : 80 }}>
          {parseInt(text.has_account) === 1 && (
            <Tooltip title="Set Permission">
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  setSelectedData(text);
                  setSetPermissionDrawer(true);
                }}
                icon={<SettingOutlined />}
              />
            </Tooltip>
          )}
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getEmployeeList = useCallback(() => {
    var params = {
      user_id: userData.data.usersmerchantemployee.merchant_user_id,
      status: 1,
    };
    axios
      .get("user/merchant/employee-list", { params })
      .then((response) => {
        const data = response.data;
        setEmployeeList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.usersmerchantemployee.merchant_user_id]);

  useEffect(() => {
    getEmployeeList();
  }, [getEmployeeList]);

  const searchable = employeeList.data.filter((data) => {
    return (
      data.lastname.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
      data.firstname.toLowerCase().indexOf(search.toLowerCase()) >= 0
    );
  });

  return (
    <MerchantEmployeeLayout>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }}>
          <Input
            id="search"
            placeholder="Search name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>
      </div>

      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.id}
        />
      </div>

      {setPermissionDrawer && (
        <MerchantEmployeeSetPermission
          open={setPermissionDrawer}
          close={() => setSetPermissionDrawer(false)}
          setLoading={setLoading}
          rerun={() => getEmployeeList()}
          selectedData={selectedData}
        />
      )}
    </MerchantEmployeeLayout>
  );
};

export default MerchantEmployeeList;
